"use strict";
/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
function getTimelineMaxTime(descriptor) {
    var max = 0;
    for (var selector in descriptor) {
        var group = descriptor[selector];
        for (var output in group) {
            var keyframes = group[output];
            if (typeof keyframes !== 'object') {
                // In case this is run before migrations, continue (non-object keyframes means only 0-keyframe).
                continue;
            }
            var keys = Object.keys(keyframes);
            for (var i = 0; i < keys.length; i++) {
                var key = parseInt(keys[i], 10);
                if (key > max) {
                    max = key;
                }
            }
        }
    }
    return max;
}
exports.default = getTimelineMaxTime;
//# sourceMappingURL=getTimelineMaxTime.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/core/lib/helpers/getTimelineMaxTime.js
// module id = 127
// module chunks = 35783957827783 127651196306611 162898551421021